import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      videoList: [{ name: "", videos: [{ teacher: "", thumbUrl: "" }] }],
      video: { videos: [] },
      chapter: { name: "", collect: false, collectNum: 0, vcId: 0 },
      loadingVideo: true,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: true, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: "" //url地址
          }
        ],
        poster: "", //你的封面地址
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true //全屏按钮
        }
      },
      timer: null,
      counter: 0 // 秒
    };
  },
  created: function() {
    // 加载课程和课程列表
    this.loadVideoData();
  },
  beforeRouteLeave: function(to, from, next) {
    next(false); // 先阻止
    if (this.timer !== null) {
      clearInterval(this.timer);
      this.timer = null;
    }
    next();
  },
  methods: {
    async loadVideoData() {
      const loadingInstance = this.$loading({ text: "加载中" });
      let res = await httpRequest(
        "/app/course/video/" + this.$route.query.vcId,
        "get",
        null
      );
      if (res !== null && res !== undefined && res.code === 200) {
        this.chapter = res.data;
        this.playerOptions.sources[0].src = this.chapter.videoUrl;
        this.playerOptions.poster = this.chapter.thumbUrl;
      }
      // 继续请求课程章节列表数据
      res = await httpRequest(
        "/app/course/video/section/" + this.$route.query.csId,
        "get",
        null
      );
      if (res !== null && res !== undefined && res.code === 200) {
        this.video = res.data;
      }
      // 最后请求课程列表
      res = await httpRequest("/app/course/video/courses", "get", null);
      if (res !== null && res !== undefined && res.code === 200) {
        this.videoList = res.data;
      }
      loadingInstance.close();
    },
    onPlayerPlay() {
      if (this.timer !== null) {
        clearInterval(this.timer);
        this.timer = null;
      }
      const _this = this;
      this.timer = setInterval(async function() {
        if (_this.counter >= 60) {
          // 上传一次记录
          const params = { courseId: _this.chapter.vcId };
          await httpRequest("/app/course/duration", "put", params);
          _this.counter = 0;
        } else {
          _this.counter++;
        }
      }, 1000);
    },
    onPlayerPause() {
      if (this.timer !== null) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    onPlayerEnded() {
      if (this.timer !== null) {
        clearInterval(this.timer);
        this.timer = null;
        this.counter = 0;
      }
    },
    onPlayerWaiting() {
      this.loadingVideo = true;
    },
    onPlayerLoadeddata() {
      this.loadingVideo = false;
    },
    async toggleColection() {
      const params = {
        vcId: this.chapter.vcId,
        validFlag: !this.chapter.collect
      };
      const res = await httpRequest("/app/course/collect", "put", params);
      if (res !== null && res !== undefined && res.code === 200) {
        this.chapter.collect = !this.chapter.collect;
        this.chapter.collectNum = this.chapter.collect
          ? this.chapter.collectNum + 1
          : this.chapter.collectNum - 1;
        this.$message.success(this.chapter.collect ? "已收藏" : "已取消收藏");
      }
    },
    getDuration(duration) {
      const hourStr =
        duration / 3600 < 10
          ? "0" + parseInt(duration / 3600)
          : parseInt(duration / 3600);
      duration = duration % 3600;
      const minStr =
        duration / 60 < 10
          ? "0" + parseInt(duration / 60)
          : parseInt(duration / 60);
      const secStr = duration % 60 < 10 ? "0" + (duration % 60) : duration % 60;
      return hourStr + ":" + minStr + ":" + secStr;
    },
    changeChapter(chapterIdx) {
      if (this.timer !== null) {
        clearInterval(this.timer);
        this.timer = null;
        this.counter = 0;
      }
      this.chapter = this.video.videos[chapterIdx];
      this.$refs.videoPlayer.player.pause();
      this.$refs.videoPlayer.options.sources[0].src = this.chapter.videoUrl;
      this.$refs.videoPlayer.options.poster = this.chapter.thumbUrl;
      this.$refs.videoPlayer.player.play();
    },
    changeVideoCourse(videoIdx) {
      if (this.timer !== null) {
        clearInterval(this.timer);
        this.timer = null;
        this.counter = 0;
      }
      this.video = this.videoList[videoIdx];
      this.chapter = this.video.videos[0];
      this.$refs.videoPlayer.player.pause();
      this.$refs.videoPlayer.options.sources[0].src = this.chapter.videoUrl;
      this.$refs.videoPlayer.options.poster = this.chapter.thumbUrl;
      this.$refs.videoPlayer.player.play();
    }
  }
};
